import { versionToJson } from '../../machineapp_utils';
const { simpleClone } = require('../../../helpers');


export function MachineAppConfiguration(pLibrary, pType, pUuid, pName, pVersion, pData, pVid) {
  this.mLibrary = pLibrary;
  this.mType = pType;
  this.mUuid = pUuid;
  this.mName = pName;
  this.mVersion = pVersion;
  this.mData = pData;

  this.mVid = pVid; // Cad-Only
}

/**
   * @returns {MachineAppLibrary}
   */
MachineAppConfiguration.prototype.getLibrary = function () { return this.mLibrary; };
MachineAppConfiguration.prototype.setDirty = function (pOnSuccess, pOnError) { this.getLibrary().upsert(this.getItemType(), this, pOnSuccess, pOnError, { saveImmediate: true }); };
MachineAppConfiguration.prototype.getType = function () { return this.mType; };
MachineAppConfiguration.prototype.getUuid = function () { return this.mUuid; };
MachineAppConfiguration.prototype.getVid = function () { return this.mVid; }; // Cad-Only
MachineAppConfiguration.prototype.getName = function () { return this.mName; };
MachineAppConfiguration.prototype.getData = function () { return this.mData; };
MachineAppConfiguration.prototype.setName = function (pName, pCallback) { this.mName = this.mLibrary.uniqueConfigurationName(pName); this.setDirty(pCallback); };
MachineAppConfiguration.prototype.setData = function (pConfiguration, pCallback) { this.mData = pConfiguration; this.setDirty(pCallback); };
MachineAppConfiguration.prototype.getItemType = function () { return 'configuration'; };
MachineAppConfiguration.prototype.cloneConfiguration = function () {
  const data = simpleClone(this.toJson());
  return new MachineAppConfiguration(this.mLibrary, data.type, data.uuid, data.name, data.version, data.configuration, this.mVid);
};
MachineAppConfiguration.prototype.toJson = function () {
  return {
    type: this.getType(),
    uuid: this.getUuid(),
    name: this.getName(),
    version: versionToJson(this.mVersion),
    configuration: this.getData(),
    itemType: this.getItemType()
  };
};
